
<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">
<span *ngIf="$.row && $.adata.fetch_key && $.row[$.adata.fetch_key] !== '0001-01-01T00:00:00' ; else dash" >{{ $.row[$.adata.fetch_key]  | Age}} </span>
<ng-template #dash>
  <span>-</span>
</ng-template>
</ng-container>
